import type { JSX } from 'react'
import type { MultiColumnsGap } from '../MultiColumns.h'

import React, { useMemo } from 'react'
import { LabelWithBorderLeft } from 'atoms/Label/Templates'
import {
  MultiColumnsAlignItems,
  MultiColumnsDirection,
  MultiColumnsJustifyContent,
  MultiColumnsRowGap,
} from '../MultiColumns.h'
import { MultiColumnsItemStyled } from '../MultiColumns.styled'

export interface IMultiColumnsItemProps {
  children: React.ReactNode
  width?: number
  direction?: MultiColumnsDirection
  alignItems?: MultiColumnsAlignItems
  justifyContent?: MultiColumnsJustifyContent
  columnGap?: MultiColumnsGap
  rowGap?: MultiColumnsRowGap
  free?: boolean
  purchaseTitle?: string
  rented?: boolean
}

export const MultiColumnsItem = ({
  children,
  width = 0,
  direction = MultiColumnsDirection.Column,
  alignItems = MultiColumnsAlignItems.FlexStart,
  justifyContent = MultiColumnsJustifyContent.FlexStart,
  columnGap,
  rowGap = MultiColumnsRowGap.INDENT_0,
  free,
  purchaseTitle,
  rented,
}: IMultiColumnsItemProps): JSX.Element | null => {
  const hasChilden = useMemo(() => {
    for (const child of React.Children.toArray(children)) {
      if (React.isValidElement(child)) {
        return true
      }
    }
    return false
  }, [children])

  return hasChilden ? (
    <MultiColumnsItemStyled
      width={width}
      direction={direction}
      alignItems={alignItems}
      justifyContent={justifyContent}
      columnGap={columnGap}
      rowGap={rowGap}
    >
      {free != null && !free && (
        <LabelWithBorderLeft
          title={rented ? purchaseTitle : ''}
          withIcon={!rented}
        />
      )}
      {children}
    </MultiColumnsItemStyled>
  ) : null
}
